module.exports = __webpack_public_path__ + "static/img/icon-homeActive.da0446ac.png";